import styles from "./index.module.less";
import classNames from "classnames";

export default function UserDescCard({ className, record }) {
  return (
    <a
      className={classNames([styles.card, className])}
      target="_blank"
      href={record?.link}
      rel="noreferrer"
    >
      <div className={styles.info}>
        <div className={styles.avatar}>
          <img src={record?.avatar[0]?.url} alt={record?.name} />
        </div>
        <div className={styles.title}>{record?.name}</div>
        <div className={styles.action}>{record?.desc}</div>
      </div>
      <div className={styles.gallery}>
        <div className={styles.top}>
          <div className={styles.img}>
            <img src={record?.pin1[0].url} alt="第一张采集" />
          </div>
        </div>
        <div className={styles.bottom}>
          <div className={styles.img}>
            <img src={record?.pin2[0].url} alt="第二张采集" />
          </div>
          <div className={styles.img}>
            <img src={record?.pin3[0].url} alt="第三张采集" />
          </div>
          <div className={styles.img}>
            <img src={record?.pin4[0].url} alt="第四张采集" />
          </div>
        </div>
      </div>
    </a>
  );
}
